<script setup lang="ts">
const emit = defineEmits(['start']);
</script>

<template>
  <h1>
    Celebrate your love at the iconic
    <br />
    One Times Square!
  </h1>

  <p>Welcome to EVER, where the magic of New York City meets your most cherished moments. Whether it's a wedding ceremony, a vow renewal, a heartfelt proposal, or a promise pledge, EVER offers an unparalleled experience as you declare your love in one of the world's most iconic settings.</p>

  <div>
    <p><b>Ceremony packages include:</b></p>
    <ul class="list-disc list-inside !ml-[3rem]">
      <li>60- or 120-minute celebration in one of our three rooms</li>
      <li>Experienced officiant and dedicated day-of coordinator</li>
      <li>Hospitality and event expertise</li>
      <li>Keepsake to remember your day</li>
      <li>Photo options from the balcony overlooking Times Square to other unique set pieces</li>
      <li>Intimate celebrations designed for groups of 10 or less with packages that range from $500 - $2,500</li>
    </ul>
  </div>

  <p><b>Reserve your date now and be the first to book in 2025!</b></p>

  <div class="form-actions" style="justify-content: center">
    <TheButton class="!bg-[var(--ever-color)] hover:!border-[var(--ever-color)] hover:!bg-white" @click="emit('start')">START</TheButton>
  </div>
</template>
